export type MdModule = {
  html: string;
  attributes: Record<string, string>;
};

/** Groups import.meta.glob results ('./en/deposit-crypto.md' → ...) into { 'deposit-crypto': { en: load } }. */
export const byLang = (files: Record<string, () => Promise<MdModule>>) => {
  const docs: Record<
    string,
    Partial<Record<string, () => Promise<MdModule>>>
  > = {};
  for (const [path, load] of Object.entries(files)) {
    const [, lang, file] = path.split('/');
    const name = file.slice(0, -'.md'.length);
    docs[name] ??= {};
    docs[name][lang] = load;
  }
  return docs;
};
